"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames = _interopRequireDefault(require("classnames"));
var _Button = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Button"));
var _TextField = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/TextField"));
var _Checkbox = _interopRequireDefault(require("@mulesoft/anypoint-components/raw/components/Checkbox"));
var _ToggleButton = require("../ToggleButton");
var _types = require("../../types");
var _utils = require("../utils");
var _hooks = require("../hooks");
var _utils2 = require("../../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
var styles = {
  "values-dropdown": "values-dropdown_tbJiG1",
  "valuesDropdown": "values-dropdown_tbJiG1",
  "dropdown": "dropdown_2zHS-m",
  "dropdown-header": "dropdown-header_3hhHJR",
  "dropdownHeader": "dropdown-header_3hhHJR",
  "dropdown-content": "dropdown-content_2HQXVI",
  "dropdownContent": "dropdown-content_2HQXVI",
  "dropdown-list": "dropdown-list_1OLZWu",
  "dropdownList": "dropdown-list_1OLZWu",
  "dropdown-list-item": "dropdown-list-item_2hd_Kn",
  "dropdownListItem": "dropdown-list-item_2hd_Kn",
  "clickable-list-item": "clickable-list-item_3HPhr2",
  "clickableListItem": "clickable-list-item_3HPhr2",
  "list-item-label": "list-item-label_2f74g5",
  "listItemLabel": "list-item-label_2f74g5",
  "list-item-description": "list-item-description_1fAgHp",
  "listItemDescription": "list-item-description_1fAgHp",
  "dropdown-footer": "dropdown-footer_2hVH4Y",
  "dropdownFooter": "dropdown-footer_2hVH4Y",
  "dropdown-footer-actions": "dropdown-footer-actions_c7mo32",
  "dropdownFooterActions": "dropdown-footer-actions_c7mo32",
  "date-input": "date-input_1iHlQ-",
  "dateInput": "date-input_1iHlQ-",
  "freeform-item": "freeform-item_1kJMvu",
  "freeformItem": "freeform-item_1kJMvu",
  "selected-title": "selected-title_2t34w9",
  "selectedTitle": "selected-title_2t34w9",
  "toggle-button": "toggle-button_lOY2Hp",
  "toggleButton": "toggle-button_lOY2Hp"
}; 
require('./ValuesDropdown.css');
const DROPDOWN_ID = 'custom-fields-values-dropdown';
const ValuesDropdown = ({
  options,
  onSubmit,
  values = [],
  dataType
}) => {
  const [searchTerm, setSearchTerm] = (0, _react.useState)('');
  const [freeform, setFreeform] = (0, _react.useState)('');
  const [selectedValues, setSelectedValues] = (0, _react.useState)(values);
  const valuesRef = (0, _react.useRef)();
  const selectValues = (0, _react.useCallback)(() => onSubmit(selectedValues), [selectedValues, onSubmit]);
  const {
    handleBlur,
    handleKeyDown,
    isExpanded,
    isFocused,
    closeDropdown,
    toggleDropdown
  } = (0, _hooks.useDropdown)({
    onBlur: selectValues
  });
  const isFreeformValue = (0, _react.useCallback)(value => {
    return !(options !== null && options !== void 0 && options.includes(value));
  }, [options]);
  const filteredValues = (0, _react.useMemo)(() => (options !== null && options !== void 0 ? options : []).filter(option => (0, _utils.includesTerm)(option, searchTerm)), [options, searchTerm]);
  const filteredSelected = (0, _react.useMemo)(() => {
    const currentAndSelectedFreeform = [...(freeform && isFreeformValue(freeform) ? [freeform] : []), ...selectedValues.filter(selectedVal => !options.includes(selectedVal))];
    const filtered = currentAndSelectedFreeform.filter(activeValues => {
      return (0, _utils.includesTerm)(activeValues, searchTerm);
    });
    return [...new Set(filtered)];
  }, [selectedValues, isFreeformValue, freeform, options, searchTerm]);
  const handleValueSelect = (0, _react.useCallback)((selectedValue, checked) => {
    const indexInArray = selectedValues.indexOf(selectedValue);
    if (indexInArray !== -1) {
      const newValues = [...selectedValues];
      newValues.splice(indexInArray, 1);
      setSelectedValues(newValues);
    } else if (checked.value) {
      setSelectedValues(selectedValues.concat([selectedValue]));
    }
  }, [selectedValues]);
  const handleClear = (0, _react.useCallback)(() => {
    var _valuesRef$current;
    setSelectedValues([]);
    (_valuesRef$current = valuesRef.current) === null || _valuesRef$current === void 0 || _valuesRef$current.focus();
  }, []);
  const handleApply = (0, _react.useCallback)(() => {
    selectValues();
    closeDropdown();
  }, [selectValues, closeDropdown]);
  const getButtonLabel = (0, _react.useCallback)(() => {
    if (selectedValues.length === 1) {
      return (0, _utils2.formatTerm)(dataType, selectedValues[0]);
    }
    if (selectedValues.length > 1) {
      return `${selectedValues.length} values`;
    }
    return 'Select a value';
  }, [selectedValues]);
  const onSearchTermChange = (0, _react.useCallback)(({
    value: term
  }) => {
    setSearchTerm(term);
    setFreeform(term);
  }, []);
  const handleListKeyDown = (0, _hooks.useArrowHandling)(valuesRef, [options]);
  const handleItemKeyDown = (0, _react.useCallback)(event => {
    const target = event.target;
    const checkbox = target.querySelector('input');
    if (event.key === ' ' && checkbox) {
      if (checkbox.checked) {
        const elements = [...valuesRef.current.querySelectorAll('li')];
        const focusedItemIndex = elements.findIndex(element => element === target);
        (0, _utils.focusNext)(focusedItemIndex, elements);
      }
      checkbox.click();
    }
  }, []);
  const getTextField = () => {
    let targetType;
    if (dataType === _types.FacetsCustomFieldType.Date) {
      targetType = 'date';
    } else if (dataType === _types.FacetsCustomFieldType.ListOfNumbers || dataType === _types.FacetsCustomFieldType.Number) {
      targetType = 'number';
    } else {
      targetType = 'search';
    }
    return /*#__PURE__*/_react.default.createElement(_TextField.default, {
      type: targetType,
      placeholder: "Search or enter a value",
      size: "md",
      onChange: onSearchTermChange,
      value: searchTerm,
      className: styles.searchInput
    });
  };
  const getTopValues = (0, _react.useCallback)(() => {
    const topValues = searchTerm ? filteredSelected : selectedValues;
    if (topValues.length) {
      return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !searchTerm ? /*#__PURE__*/_react.default.createElement("span", {
        className: styles.selectedTitle
      }, "Selected") : null, topValues.map(topValue => /*#__PURE__*/_react.default.createElement("li", {
        className: (0, _classnames.default)(styles.dropdownListItem, {
          [styles.freeformItem]: isFreeformValue(topValue)
        }),
        key: topValue,
        role: "option",
        "aria-selected": selectedValues.includes(topValue),
        tabIndex: -1,
        onKeyDown: handleItemKeyDown
      }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
        label: (0, _utils2.formatTerm)(dataType, topValue),
        checked: selectedValues.includes(topValue),
        onChange: e => handleValueSelect(topValue, e)
      }))), /*#__PURE__*/_react.default.createElement("hr", null));
    }
    return null;
  }, [selectedValues, filteredSelected]);
  return (
    /*#__PURE__*/
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
    _react.default.createElement("div", {
      "data-test-id": "custom-fields-filter",
      className: styles.valuesDropdown,
      onKeyDown: handleKeyDown,
      onBlur: handleBlur
    }, /*#__PURE__*/_react.default.createElement(_ToggleButton.ToggleButton, {
      type: "secondary",
      label: getButtonLabel(),
      active: !isExpanded && !!selectedValues.length,
      className: styles.toggleButton,
      expanded: isExpanded,
      controls: DROPDOWN_ID,
      isFocused: isFocused,
      onClick: toggleDropdown
    }), isExpanded && /*#__PURE__*/_react.default.createElement("div", {
      className: styles.dropdown,
      "data-test-id": "custom-fields-values-dropdown",
      id: DROPDOWN_ID,
      role: "listbox",
      tabIndex: -1
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.dropdownHeader
    }, getTextField()), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.dropdownContent
    }, /*#__PURE__*/_react.default.createElement("ul", {
      role: "listbox",
      className: styles.dropdownList,
      id: "cf-options-dropdown",
      ref: valuesRef,
      tabIndex: 0,
      onKeyDown: handleListKeyDown
    }, getTopValues(), filteredValues.map(filteredValue => /*#__PURE__*/_react.default.createElement("li", {
      className: (0, _classnames.default)(styles.dropdownListItem, {
        [styles.freeformItem]: isFreeformValue(filteredValue)
      }),
      key: filteredValue,
      role: "option",
      "aria-selected": selectedValues.includes(filteredValue),
      tabIndex: -1,
      onKeyDown: handleItemKeyDown
    }, /*#__PURE__*/_react.default.createElement(_Checkbox.default, {
      label: (0, _utils2.formatTerm)(dataType, filteredValue),
      checked: selectedValues.includes(filteredValue),
      onChange: e => handleValueSelect(filteredValue, e)
    }))))), /*#__PURE__*/_react.default.createElement("div", {
      className: styles.dropdownFooter
    }, /*#__PURE__*/_react.default.createElement("div", {
      className: styles.dropdownFooterActions
    }, /*#__PURE__*/_react.default.createElement(_Button.default, {
      kind: "tertiary",
      disabled: !selectedValues.length,
      onClick: handleClear
    }, "Clear selection"), /*#__PURE__*/_react.default.createElement(_Button.default, {
      kind: "secondary",
      onClick: handleApply
    }, "Apply")))))
  );
};
var _default = exports.default = ValuesDropdown;
//# sourceMappingURL=ValuesDropdown.js.map